import { render, staticRenderFns } from "./AdditionalSampleDeclarationList.vue?vue&type=template&id=7890875e&scoped=true&"
import script from "./AdditionalSampleDeclarationList.vue?vue&type=script&lang=js&"
export * from "./AdditionalSampleDeclarationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7890875e",
  null
  
)

export default component.exports